import React from 'react';
import type { Question, Language } from '@nordcrest/shared';

interface ScaleProps {
  question: Question;
  value: number | null;
  onChange: (value: number) => void;
  language: Language;
  error?: string;
}

export function Scale({ question, value, onChange, language, error }: ScaleProps) {
  const min = question.validation?.min || 1;
  const max = question.validation?.max || 5;
  const range = Array.from({ length: max - min + 1 }, (_, i) => min + i);

  return (
    <div>
      <div className="flex justify-between items-center gap-2">
        {range.map((num) => (
          <button
            key={num}
            type="button"
            onClick={() => onChange(num)}
            className={`flex-1 py-4 rounded-lg border-2 font-semibold text-lg transition-all duration-200 ${
              value === num
                ? 'border-primary-500 bg-primary-500 text-white'
                : 'border-gray-200 text-gray-700 hover:border-primary-300 hover:bg-primary-50'
            }`}
          >
            {num}
          </button>
        ))}
      </div>

      {question.description && (
        <p className="text-sm text-gray-500 mt-3 text-center">{question.description[language]}</p>
      )}

      {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
    </div>
  );
}
